import { useCallback } from 'react'
import { useSetRecoilState } from 'recoil'
import { accessRolesState } from '../states/access-roles-state'
import axios from 'axios'
import { getServerHost } from '../utils/get-server-host'
import { getHeaders } from '../utils/get-headers'
import { accountsState } from '../states/accounts-state'

export const fetchAccounts = async () => {
  try {
    const result = await axios.get(getServerHost('accounts'), { headers: getHeaders() })

    if (result.status === 200) {
      return result.data.accounts
    }
  } catch (error) {
    console.log(error)
  }
}

export const useFetchAccounts = () => {
  const set = useSetRecoilState(accountsState)

  return useCallback(async () => {
    const items = await fetchAccounts()

    if (Array.isArray(items)) {
      set(items)
    }
  }, [])
}